import { PLANBOOK_API_HOSTNAME, INTERACTION_HOSTNAME, CLIENT_HOSTNAME, TOOL_API_HOSTNAME } from 'common/utils/variables'
import { axios, reqInterceptor, reqErr, repInterceptor, repErr } from './axios'
import { API_LIST } from 'api/config'

const apis = {}
const api = `${PLANBOOK_API_HOSTNAME}/planBook/V2`
const baseUrlMap = {
  'tool-api': TOOL_API_HOSTNAME,
  'interaction-api': INTERACTION_HOSTNAME,
  'client-winbaoxian': CLIENT_HOSTNAME
}
const initApis = (apiName, type, interceptors, base) => {
  let instance = axios.create()
  let [key, name] = apiName
  let iapi = api

  // 自定义路径
  if (name.indexOf('/') > -1) {
    // 支持新api域名
    let baseOrigin = PLANBOOK_API_HOSTNAME
    if (base && baseUrlMap[base]) {
      baseOrigin = baseUrlMap[base]
    }
    iapi = baseOrigin + name.substring(0, name.lastIndexOf('/'))
    name = name.substring(name.lastIndexOf('/') + 1, name.length)
  }

  apis[key] = (params, path, config) => {
    if (interceptors) {
      instance.interceptors.request.use(reqInterceptor, reqErr)
      instance.interceptors.response.use(repInterceptor, repErr)
    }
    let ipath = path ? `/${path}` : ''
    if (type === 'post') {
      return instance
        .post(`${iapi}/${name}${ipath}`, params, config)
        .then(res => res.data)
    } else {
      return instance.get(`${iapi}/${name}${ipath}`, {
        params,
        config
      })
    }
  }
}

API_LIST.forEach(a => {
  initApis([a[0], a[1]], a[2], a[3], a[4])
})

const {
  getUser,
  getClientInfo,
  getResult,
  visitTs,
  initInterest,
  getInterest,
  preview,
  clause,
  resultMultiple,
  queryAdvert,
  getMembers,
  getFamilyResult,
  getMultiResult,
  exportPlanData,
  getCompanyList,
  getBeneficiary,
  getCompany,
  getPbCompareResult,
  saveWxClient,
  isWechatGroup,
  saveOperate,
  saveHumanPath,
  addPbCount,
  liabilities,
  compareMission,
  abTestForMultiGroup,
  diseaseCompare,
  diseaseV2,
  diseaseListV2,
  diseaseDetail,
  multiCompare,
  getResultCategory,
  getInsuranceCategory,
  compareByCategory,
  getChunYun,
  createByExample,
  getAllCondition,
  setShareName,
  getCard,
  getNewCard,
  clauseSwitch,
  getRenewRateList,
  completeMission,
  nameExplain,
  signPopup,
  haveRecommend,
  addFamilyPlanbook,
  getAccountRateList,
  getVideoList,
  updatePBProductVideoTypeInfo,
  wxClientSaveOperate,
  isTestUser,
  createGroup,
  pollingListAvailableGroups,
  validateAAT,
  modifyAAT,
  getInterestDetail,
  resultShare,
  getApplicationInfo,
  pbCompare,
  getRecords,
  saveVersionNum,
  policyInfo,
  sendAudio,
  getIrrInfo,
  getPublicResult,
  getPublicClause,
  initPublicInterest,
  getPublicInterest,
  pbCompareShare,
  getExportOption,
  getTermParseMindmap,
  validateSuperMember
} = apis

export {
  getUser,
  getClientInfo,
  getResult,
  visitTs,
  initInterest,
  getInterest,
  preview,
  clause,
  resultMultiple,
  queryAdvert,
  getMembers,
  getFamilyResult,
  getMultiResult,
  exportPlanData,
  getCompanyList,
  getBeneficiary,
  getCompany,
  getPbCompareResult,
  saveWxClient,
  isWechatGroup,
  saveOperate,
  saveHumanPath,
  addPbCount,
  liabilities,
  compareMission,
  abTestForMultiGroup,
  diseaseCompare,
  diseaseV2,
  diseaseListV2,
  diseaseDetail,
  multiCompare,
  getResultCategory,
  getInsuranceCategory,
  compareByCategory,
  getChunYun,
  createByExample,
  getAllCondition,
  setShareName,
  getCard,
  getNewCard,
  clauseSwitch,
  getRenewRateList,
  completeMission,
  nameExplain,
  signPopup,
  haveRecommend,
  addFamilyPlanbook,
  getAccountRateList,
  getVideoList,
  updatePBProductVideoTypeInfo,
  wxClientSaveOperate,
  isTestUser,
  createGroup,
  pollingListAvailableGroups,
  validateAAT,
  modifyAAT,
  getInterestDetail,
  resultShare,
  getApplicationInfo,
  pbCompare,
  getRecords,
  saveVersionNum,
  policyInfo,
  sendAudio,
  getIrrInfo,
  getPublicResult,
  getPublicClause,
  initPublicInterest,
  getPublicInterest,
  pbCompareShare,
  getExportOption,
  getTermParseMindmap,
  validateSuperMember
}
